import * as React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import uploadLogo from "../../assets/svg/upload.svg";
import { useNavigate } from "react-router-dom";
import { useResponsive } from "../../hooks/useResponsive";
import MenuBar from "../menuBar";
import { useRef } from "react";
import MenuAppBar from "../ownersDashboard/dashboardNavBar";
import { useDispatch, useSelector } from "react-redux";
import CarouselWithIndicator from "../../components/CarouselWithIndicator";
import storePersist, { localConstant } from "../../services/localStorage";
import BottomNav from "../../components/BottomNav/BottomNav";
import CustomDialog from "../../components/CustomDialog";
import UploadDocuments from "../uploadDocuments";
import {
  reservationsDetailsRequest,
  setSelectedReservationItem,
  getReserverationList,
  getLocationGatesList,
  doOpenGate,
  setSelectedGates,
} from "../../redux/reservations/action";
import EsignAgreementAlert from "../../components/EsignAgreementAlert";
import { sendMessageToReactNative } from "../../utils";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../utils/snackbarConfig";
import GatePin from "../ownersDashboard/gatePins";
import Alert from "../../components/Alert";
import apiConfig from "../../services/apiManager/apiConfig";
import { fetchCustomerEsignStatus } from "../../services/apiManager/apiRequests";

const OperatorDashboard = (props) => {
  const { t } = useTranslation();

  const { locationData, reservationList, gateList, selectedReservation } =
    useSelector((state) => state.reservationReducer);

  // this is for knowing the status of the documents.
  const { documentList } = useSelector((state) => state.myDocumentsReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lgUp = useResponsive("up", "lg");
  const smDown = useResponsive("down", "sm");
  const [dialogProps, setDialogProps] = React.useState({
    isOpen: false,
    Content: null,
    reset: () =>
      setDialogProps((prev) => ({ ...prev, isOpen: false, Content: null })),
  });
  const [popupDialogProps, setPopupDialogProps] = React.useState({
    isOpen: false,
    item: {},
    gate: {},
    reset: () =>
      setPopupDialogProps((prev) => ({
        ...prev,
        isOpen: false,
        item: {},
        gate: {},
      })),
  });
  React.useEffect(() => {
    window.clarity(
      "set",
      "customer_id",
      storePersist.get(localConstant.ENTITY_CUSTOMER_ID),
    );
    window.clarity("set", "user_id", storePersist.get(localConstant.USER_ID));
  }, []);
  const myRef = useRef({});

  React.useEffect(() => {
    const custId = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
    const params = {
      "q.op": "OR",
      start: "0",
      rows: "10000",
      wt: "json",
      cl: "OPS",
      fq: `reservation_status: (PNDG_COUT CONFIRMED PNDG_CONF PNDG_EXT)`,
    };
    dispatch(getReserverationList(params, (response) => {}));
  }, [locationData, dispatch]);

  React.useEffect(() => {
    if (reservationList?.length > 0) {
      const uniq = {};
      for (let index = 0; index < reservationList?.length; index++) {
        const element = reservationList[index];
        if (
          element.location_id &&
          (element.reservation_status === "CONFIRMED" ||
            element.reservation_status === "PNDG_EXT")
        ) {
          const locationId = element.location_id;
          if (!Object.keys(uniq).includes(locationId)) {
            uniq[locationId] = locationId;
          }
        }
      }
      const locations = Object.keys(uniq).toString().replace(/,/g, " ");
      if (Object.keys(uniq)?.length > 0) {
        const params = {
          fq: `location_id: (${locations})&fq=equipment_type_code:GATE&fq=equipment_status_code:ACTIVE&start=0&rows=10000`,
        };
        dispatch(getLocationGatesList(params, (response) => {}));
      }
    }
  }, [reservationList, dispatch]);

  React.useEffect(() => {
    const getEsignInformation = async () => {
      const esignStatus = await fetchCustomerEsignStatus();
      if (esignStatus?.agrmntStatusCd && esignStatus?.agrmntId) {
        storePersist.set(
          localConstant.AGREEMENT_STATUS,
          esignStatus?.agrmntStatusCd,
        );
        storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
      }
    };

    getEsignInformation();
  }, []);

  const onMessageFromRN = (message) => {
    try {
      const { action, payload } = JSON.parse(message);
      if (action === "User_Location") {
        dispatch(
          doOpenGate(
            {
              lat: payload?.coords?.latitude,
              lng: payload?.coords?.longitude,
              gateId: selectedReservation?.equipment_id || "",
              reservationId: selectedReservation?.reservation_id,
            },
            (response) => {
              console.log("doOpenGate Response:", response);
            },
          ),
        );
      }
    } catch (error) {
      console.error("Error parsing message:", error);
    }
  };

  const customerEsignStatus = async () => {
    if (
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLTD" ||
      storePersist.get(localConstant.AGREEMENT_STATUS) === "COMPLETED"
    ) {
      return true;
    } else {
      const esignStatus = await fetchCustomerEsignStatus();
      if (
        esignStatus?.agrmntStatusCd === "COMPLETED" ||
        esignStatus?.agrmntStatusCd === "COMPLTD"
      ) {
        storePersist.set(
          localConstant.AGREEMENT_STATUS,
          esignStatus?.agrmntStatusCd,
        );
        storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
        return true;
      }
      storePersist.set(localConstant.AGREEMENT_ID, esignStatus?.agrmntId);
      return false;
    }
  };

  const displayEsginRequestMessage = (item, gate) => {
    setPopupDialogProps((prev) => ({
      ...prev,
      isOpen: true,
      item,
      gate,
    }));
  };

  // Attach the handler to `window` so we can access it from
  // scripts injected by React Native WebView.
  window.onMessageFromRN = onMessageFromRN;

  const openGateForDriver = (item, gate) => {
    let { equipment_id } = gate || {};
    dispatch(setSelectedReservationItem({ ...item, equipment_id }));
    sendMessageToReactNative("GET_DEVICE_LOCATION");
  };

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <MenuAppBar myRef={myRef} title={t("pages.ownerDashboard.pageHeading")} />
      <MenuBar myRef={myRef} activeTab={0} />

      <Box sx={{ ...(lgUp && { m: 3.5 }) }}>
        <Stack>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              margin: 10,
            }}
          >
            <Typography
              style={{
                fontFamily: "Segoe UI",
                fontSize: 16,
                fontWeight: 700,
                letterSpacing: 0,
                textAlign: "left",
                color: "#1D5AB9",
              }}
            >
              {`${t("pages.ownerDashboard.title01")} (${
                reservationList?.length ? reservationList?.length : 0
              })`}
            </Typography>
          </div>
          {reservationList?.length > 0 && (
            <CarouselWithIndicator
              data={reservationList}
              gateList={gateList}
              onClickGate={async (item, gate) => {
                const isEsignComplete = await customerEsignStatus();
                if (!isEsignComplete) {
                  displayEsginRequestMessage(item, gate);
                } else {
                  openGateForDriver(item, gate);
                }
              }}
              onPress={(item, gates) => {
                dispatch(setSelectedGates(gates));
                dispatch(setSelectedReservationItem(item));
                dispatch(
                  reservationsDetailsRequest(
                    item?.reservation_id,
                    (response) => {
                      navigate("/reservation_details", {
                        state: {
                          spotData: response,
                          from: "/operatorDashboard",
                        },
                      });
                    },
                  ),
                );
              }}
            />
          )}
        </Stack>
        {/* removing gate pins for current release.... */}

        {/* <Grid>
          <GatePin />
        </Grid> */}

        {/* If user not uploaded any document then only it is visible */}
        {!documentList?.length > 0 && (
          <div>
            <Typography
              style={{
                fontFamily: "Segoe UI",
                fontSize: 16,
                fontWeight: 700,
                letterSpacing: 0,
                textAlign: "left",
                color: "#1D5AB9",
                margin: 10,
              }}
            >
              {t("pages.ownerDashboard.title04")}
            </Typography>
            <Stack
              style={{
                margin: 10,
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 10,
                marginTop: lgUp ? "2%" : "5%",
              }}
            >
              <Box
                border={4}
                borderLeft={0}
                borderRight={0}
                sx={{ boxShadow: 1 }}
                style={{
                  width: 104,
                  height: 71,
                  borderRadius: 8,
                  borderWidth: 1,
                  borderColor: "lightgray",
                  marginRight: `${lgUp ? "2%" : "0"}`,
                }}
              >
                <div
                  onClick={() => {
                    if (smDown) {
                      navigate("/uploadDocuments");
                      return;
                    }
                    setDialogProps((prev) => ({
                      ...prev,
                      isOpen: true,
                      title: "Upload Documents",
                      Content: UploadDocuments,
                    }));
                  }}
                  style={{
                    alignItems: "center",
                    flexDirection: "column",
                    display: "flex",
                    alignContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={uploadLogo}
                    alt="Your Alt Text"
                    style={{
                      width: 32,
                      height: 32,
                      marginTop: 7,
                      marginBottom: 7,
                      backgroundColor: "#1D5AB929",
                      borderRadius: "50%",
                    }}
                  />
                  <Typography
                    style={{
                      fontFamily: "Segoe UI",
                      fontSize: 9,
                      fontWeight: 400,
                      letterSpacing: 0,
                      textAlign: "center",
                      color: "#3A4454",
                    }}
                  >
                    {t("pages.ownerDashboard.actionItem04")}
                  </Typography>
                </div>
              </Box>
            </Stack>
          </div>
        )}
      </Box>
      {popupDialogProps.isOpen && (
        <EsignAgreementAlert
          {...popupDialogProps}
          handleGateOpen={openGateForDriver}
          displayEsignSignNow={false}
        />
      )}
      {dialogProps.isOpen && <CustomDialog {...dialogProps} />}
      <BottomNav activeTab={0} />
    </div>
  );
};

export default OperatorDashboard;
